import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IStaff } from "../../models/user";
import { selectAllEvents } from "../events/event.selectors";
import { selectSelectedStudent } from "../students/student.selectors";
import { ActivityState } from "./activity.reducer";

// Create a feature selector to select the activity state from the root state
export const selectActivityState = createFeatureSelector<ActivityState>('activities');

// Selector to get the list of activities
export const selectAllActivities = createSelector(
    selectActivityState,
    (state: ActivityState) => state.activities
);

// Selector to get the selected activity ID
export const selectSelectedActivity = createSelector(
    selectActivityState,
    (state: ActivityState) => state.selectedActivity
);

export const selectAllActivitiesWithIds = (ids: string[]) => createSelector(
    selectAllActivities,
    (activities) => activities?.filter(activity => ids.includes(activity.id)) || []
);

export const selectSelectedStudentActivities = createSelector(
    selectAllActivities,
    selectSelectedStudent,
    (activities, student) => activities?.filter(activity => student?.extracurricularIds.includes(activity.id)) || []
);

export const selectSelectedActivityEvents = createSelector(
    selectSelectedActivity,
    selectAllEvents,
    (activity, events) => {
        const eventIds = activity?.eventIds || [];
        return events.filter(event => eventIds.includes(event.id));
    }
);

export const selectAllActivityStaff = createSelector(
    selectAllActivities,
    (activities): IStaff[] => {
        return activities?.map((act) => act.coach).filter((coach): coach is IStaff => coach !== null && coach !== undefined) || [];
    }
);

export const selectSelectedActivityUpcomingEvents = createSelector(
    selectSelectedActivityEvents,
    (events) => events.filter((e) => e.start > new Date())
);

export const selectSelectedActivityPastEvents = createSelector(
    selectSelectedActivityEvents,
    (events) => events.filter((e) => e.start < new Date())
);
